export default __webpack_public_path__ + "static/media/money.85c6966f.svg";